<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
    <div class="detail__exam" :class="{mb: mobile}">
        <div class="container">
            <div class="detail__exam__first">
                <!-- Heading -->
                <template v-if="!mobile">
                    <div class="title">
                        <img src="../../../static/images/icon-st.jpg" alt="" />
                        <span>{{ nameExam === '-' ? courseName + ' - ' + $t('detailExam.finalExam') : nameExam }}</span>
                    </div>
                </template>
                <template v-if="mobile">
                    <div class="title_mb">
                        <span>{{ nameExam === '-' ? courseName + ' - ' + $t('detailExam.finalExam') : nameExam }}</span>
                    </div>
                </template>
                <!-- end heading -->

                <div class="detail__exam__back">
                    <button class="btn-tast btn-next-1 w-fit" @click="back()">
                        <img src="../../../static/images/icon-back-1.png" />
                        <span>{{ $t('common.returnButton') }}</span>
                    </button>
                </div>
                <div class="detail__exam__first__content">
                    <div class="timeline">
                        <img src="../../../static/images/svg/svg_date.svg" alt="" />
                        <i>{{ this.dateExam }}</i>
                    </div>
                    <div class="ruler">
                        <div class="ruler__devider"></div>
                        <div class="ruler__arrow"></div>
                    </div>
                    <div class="timeline">
                        <img src="../../../static/images/svg/svg_clock.svg" alt="" />
                        <i>{{ this.timeExam }}</i>
                    </div>
                    <div class="ruler">
                        <div class="ruler__devider"></div>
                        <div class="ruler__arrow"></div>
                    </div>
                    <div class="chart-container">
                        <div class="chart" id="graph1" data-size="260"></div>
                        <div class="chart" id="graph2" data-size="240"></div>
                        <div class="chart" id="graph3" data-size="215"></div>
                        <div class="chart-container__score">
                            <p>{{ $t('detailExam.fullMark') }}</p>
                            <p>{{ this.fullMark }}</p>
                            <p>{{ $t('detailExam.standardMark') }}</p>
                            <p>{{ this.standardScore }}</p>
                            <p>{{ $t('detailExam.yourMark') }}</p>
                            <p>{{ this.yourScore || 0 }}</p>
                        </div>
                    </div>
                    <div class="ruler">
                        <div class="ruler__devider"></div>
                        <div class="ruler__arrow"></div>
                    </div>
                    <div :class="`${parseFloat(this.yourScore) >= parseFloat(this.standardScore) ? ' result--success' : 'result'}`">
                        <p>{{ parseFloat(this.yourScore) >= parseFloat(this.standardScore) 
                                ? this.$t('detailExam.pass')
                                : this.$t('detailExam.fail')
                        }}</p>
                        <img :src="`../../../static/images/svg/${parseFloat(this.yourScore) >= parseFloat(this.standardScore) ? 'svg_success.svg' : 'svg_warning.svg'}`"
                            alt="warning" />
                        <div class="ruler ruler__custom" v-if="parseFloat(this.yourScore) != parseFloat(this.fullMark)">
                            <div class="ruler__devider"></div>
                            <div class="ruler__arrow"></div>
                        </div>
                        <div class="action" @click="this.goToWrongbook" v-if="parseFloat(this.yourScore) != parseFloat(this.fullMark)">
                            {{ $t('detailExam.viewDetailWrong') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail__exam__second">
                <div class="detail__exam__first__header">
                    <img src="../../../static/images/mucluc-xanh.png" alt="" />
                    <p>{{ $t('detailExam.viewChapter') }}</p>
                </div>
                <div>
                    <chartDetailExam :data="{examId: this.examId, courseId: this.courseId, id: this.recordId}"></chartDetailExam>
                </div>
            </div>

        </div>
        <loading class="loading--lesson" :showLoading="isLoadingData" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import loading from "@/components/loading/loading";
import chartDetailExam from "@/components/exam/chartDetailExam";

export default {
    data() {
        return {
            isLoadingData: null,
            examId: null,
            courseId: null,
            dataDetailExam: null,

            courseName: null,
            nameExam: null,
            dateExam: null,
            fullMark: null,
            yourScore: null,
            standardScore: null,
            currentExam: null,
            recordId: null,
            timeExam: null,
            isCurriculumExam: null,
            listDataDetailsShowDialog: null,

            listChapterName: [],
            listScore: [],
            listRightAnswer: [],
            chapterName: null
        };
    },
    computed: {
        // get data from store
        ...mapState({
            mobile: (state) => state.header.mobile,
        }),
    },
    components: {
        loading,
        chartDetailExam
    },
    async created() {
        if (this.$route.query.examId) {
            this.examId = this.$route.query.examId;
        }
        if (this.$route.query.courseId) {
            this.courseId = this.$route.query.courseId;
        }
        if (this.$route.query.isCurriculumExam) {
            this.isCurriculumExam = this.$route.query.isCurriculumExam;
        }
        await this.init();
    },
    methods: {
        async init () {
            this.isLoadingData = true;
            await this.getExamRecord();
            this.createScore("graph1", "rgba(84,112,198,1)", 100);
            this.createScore("graph2", "rgba(145,204,117,1)", this.standardScore * 100 / this.fullMark);
            this.createScore("graph3", "rgba(250,200,88,1)", this.yourScore * 100 / this.fullMark);
            this.isLoadingData = false;
        },
        
        createScore(id, colorBorder, percent) {
            var el = document.getElementById(id);
            var options = {
                percent: percent === 0 ? 1 / 5 : percent,
                size: el.getAttribute("data-size") || 220,
                lineWidth: el.getAttribute("data-line") || 15,
                rotate: el.getAttribute("data-rotate") || 0
            };

            var canvas = document.createElement("canvas");

            if (typeof G_vmlCanvasManager !== "undefined") {
                G_vmlCanvasManager.initElement(canvas);
            }

            var ctx = canvas.getContext("2d");
            canvas.width = canvas.height = options.size;

            el.appendChild(canvas);

            ctx.translate(options.size / 2, options.size / 2);
            ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI);

            var radius = (options.size - options.lineWidth) / 2;

            var drawCircle = function (color, lineWidth, percent) {
                percent = Math.min(Math.max(0, percent || 1), 1);
                ctx.beginPath();
                ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
                ctx.strokeStyle = color;
                ctx.lineCap = "round";
                ctx.lineWidth = lineWidth;
                ctx.stroke();
            };

            drawCircle("#efefef", options.lineWidth, 100 / 100);
            drawCircle(colorBorder, options.lineWidth, options.percent / 100);
        },

        getExamRecord () {
            this.$api
                .post("/home/getExamRecord", {
                    examId: this.examId || null,
                    courseId: this.courseId || null,
                    languageType: this.$lang()
                })
                .then(response => {
                    let listRecord = response.data.list
                    this.currentExam = listRecord[0];
                    const { fullMarks, res, score, dateExamEnd, examName, examDate, courseName, id, timeExamEnd, timeExamStart } = this.currentExam
                    this.nameExam      = examName;
                    this.dateExam      = examDate;
                    this.fullMark      = fullMarks;
                    this.yourScore     = score;
                    this.standardScore = res;
                    this.courseName    = courseName;
                    this.recordId      = id;

                    let start = new Date(timeExamStart);
                    let end = new Date(timeExamEnd);
                    if (end - start < 60000)
                        this.timeExam = (end - start) / 1000 + " " + this.$t('detailExam.seconds')
                    else
                        this.timeExam = Math.round((end - start) / 1000 / 60) + " " + this.$t('detailExam.minutes')
                });
        },

        goToWrongbook: function () {
            this.$router.push({
                path: "/home/exam/wrongbook",
                query: {
                    courseId: this.courseId,
                    examId: this.examId,
                    courseName: this.courseName,
                    isDetailExam: true,
                    examFlag: 0,
                    examName: this.nameExam
                },
            });
        },

        back: function () {
            this.$router.push({
                path: "/home/curriculumExam",
                query: {
                    outlineInfo: JSON.stringify({
                        courseId: this.courseId,
                        courseName: this.courseName,
                    }),
                },
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    max-width: 1180px;
    margin: 0 auto;
}

a {
    text-decoration: none;
    color: rgb(0, 4, 255);
    -webkit-tap-highlight-color: white;
    -webkit-user-select: none;
    -moz-user-focus: none;
    -moz-user-select: none;
}

.title {
    display: flex;
    height: auto;
}
.title img {
    width: 40px;
    margin-bottom: 3px;
}
.title span {
    font-size: 24px;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
    display: flex;
    padding-left: 10px;
}

.title_mb {
    width: calc(100% - 160px);
    position: fixed;
    font-weight: bold;
    top: 0;
    left: 48px;
    z-index: 1000;
    background-color: #0071c5;
    height: 60px;
    color: #fff;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 60px !important;
    padding-left: 2px;
}

.detail__exam {
    padding: 30px 0;
}

.detail__exam__first__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
}

.w-fit {
    width: fit-content;
}

.detail__exam__back {
    padding-top: 40px;
}

.mb .detail__exam__back {
    padding-top: unset;
}
@media (max-width: 768px) {
    .detail__exam__first__content {
        display: flex;
        flex-direction: column;
    }

    .echart-detail {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}

.detail__exam__first__header img {
    max-width: 40px;
}

.detail__exam__first__header p {
    padding-left: 10px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 39px;
}

.detail__exam__first__content {
    display: flex;
    align-items: center;
    padding: 0 5%;
}

.detail__exam__first__content p {
    padding-left: 10px;
}

.detail__exam__first__content .timeline {
    display: flex;
    align-items: center;
    min-width: fit-content;
}

.detail__exam__first__content .timeline i {
    font-size: 15px;
    padding-left: 10px;
}

.detail__exam__first__content .timeline p {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #000000;
}

.detail__exam__first__content .result {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0px;
}

.detail__exam__first__content .result p {
    padding: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #f17272;
    text-transform: uppercase;
}

.detail__exam__first__content .result--success {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0px;
}

.detail__exam__first__content .result--success p {
    padding: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #5470c6;
    text-transform: uppercase;
}

.action {
    padding: 10px 15px;
    background: #f17272;
    color: white;
    border-radius: 10px;
    margin: 20px 0;
    cursor: pointer;
    transition: ease-out 0.5s;
    user-select: none;
    min-width: fit-content;
    text-align: center
}

.action:hover {
    background: #e95050;
}

.action:active {
    transform: scale(0.6);
    background: #d63737;
}

.detail__exam__first__content .ruler {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 20px;
}

.ruler__custom {
    transform: rotate(90deg);
    margin-top: 20px;
    width: 50%;
}

@media (max-width: 768px) {
    .detail__exam__first__content .ruler {
        transform: rotate(90deg);
        min-height: 120px;
    }

    .ruler__custom {
        width: 100%;
    }
}

.detail__exam__first__content .ruler__devider {
    width: 100px;
    border: 1px solid #273a7e;
    transform: matrix(1, 0, 0, 1, 0, 0);
}

.detail__exam__first__content .ruler__arrow {
    border: solid #273a7e;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.chart-container {
    position: relative;
    min-width: 250px;
    height: 300px;
}

.chart-container .chart-container__score {
    z-index: -1;
    position: relative;
    top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.chart-container .chart-container__score p:nth-child(odd) {
    padding: 3px 0;
}

.chart-container .chart-container__score p:nth-child(even) {
    padding: 6px 20px;
    border-radius: 20px;
    font-weight: 600;
    font-weight: bolder;
}

.chart-container .chart-container__score p:nth-child(2) {
    border: solid 2px rgba(84, 112, 198, 1);
    color: rgba(84, 112, 198, 1);
}

.chart-container .chart-container__score p:nth-child(4) {
    border: solid 2px rgba(145, 204, 117, 1);
    color: rgba(145, 204, 117, 1);
}

.chart-container .chart-container__score p:nth-child(6) {
    border: solid 2px rgba(250, 200, 88, 1);
    color: rgba(250, 200, 88, 1);
}

 .detail__exam__second .echart-detail {
    display: flex;
    padding: 20px 40px;
    position: relative;
    flex-wrap: wrap;
}
#chartContainer{
    position: relative;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;
}

 .ee {
    width: 100%;
    min-height: 1180px;
}

#graph2 {
    position: absolute;
    top: 11px;
    left: 10px;
}

 #graph3 {
    position: absolute;
    top: 23px;
    left: 20px;
} 

input {
    width: 200px;
} 

.modal { 
    position: fixed;
    /* Stay in place */
    z-index: 1001;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
    background-color: #fefefe;
    /* background-image: linear-gradient(0deg, #d5f1ff 0%, #53e0fd 100%); */
    margin: auto;
    padding: 0px 10px;
    border: 1px solid #888;
    width: 50%;
    border-radius: 10px;
    min-height: 100px;
}


.modal_header {
    padding-top: 5px;
}

.modal_body {
    padding-top: 20px;
}

.modal_body_exam {
    display: flex;
}

.modal_body_exam .modal_body_exam_title {
    font-size: 13px;
    width: 50%;
    padding-top: 1vh;
}

.modal_body_exam_title_tl {
    font-weight: bold;
}

.modal_body_currilumn {
    padding-top: 2vh;
    padding-bottom: 2vh;
}

.modal_body_currilumn_header {
    font-size: 14px;
    font-weight: bold;
}

.modal_body_currilumn_header_hd {
    display: flex;
    padding: 1vh 0vh;
    font-size: 13px;
}

.modal_body_currilumn_header_hd span {
    font-weight: bold;
}

.modal_body_currilumn_header_bd {
    padding: 1vh 0vh;
    display: flex;
    font-size: 13px;
}

.tnv_ct {
    width: 60%;
}

.tnv_as {
    width: 20%;
    text-align: center;
}

.tnv_score {
    width: 20%;
    text-align: center;
}

/* MB */
.content_new .btn_show_details_exam {
    background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
    padding: 3px 8px;
    border-radius: 15px;
    -webkit-transition: 0.5s ease;
    transition: 0.5s ease;
    color: #fff;
}

.modal_MB .modal-content {
    width: 90% !important;
}

.modal_body_exam_mb {
    display: none;
}

@media (max-width: 480px) {
    .modal_body_exam_mb {
        display: unset;
    }

    .modal_body_exam_mb .modal_body_exam {
        border-bottom: 1px solid #e2dfdf;
    }

    .modal_body_exam_mb .modal_body_exam_title {
        width: 100%;
    }

    .modal_body_exam_pc {
        display: none;
    }

    .modal_body_exam_title_ct {
        float: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/detailExam.vue